import React, { useEffect, useState } from "react";
import {
  Box,
  ClickAwayListener,
  FormControlLabel,
  Grid,
  LinearProgress,
  RadioGroup,
  makeStyles,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppColor from "utilities/AppColor";
import PropTypes from "prop-types";
import classNames from "classnames";
import AppUtil from "utilities/AppUtil";

import InputSearch from "components/Input/InputSearch";
import { useDispatch } from "react-redux";
import { getWorkerToBooking, bookWorkerForJob } from "store/slices/job";
import { reduceCalculatePrice } from "store/slices/rate";
import JobUserTag from "./JobUserTag";
import moment from "moment";
import { DAYS_OF_WEEK } from "config/AppConfig";
import AppDialog from "components/Dialog/AppDialog";
import AppButton from "components/CustomButtons/AppButton";

import MorningIcon from "assets/icons/morning.svg";
import AfternoonIcon from "assets/icons/afternoon.svg";
import EveningIcon from "assets/icons/evening.svg";
import NightIcon from "assets/icons/night.svg";
import PlusIcon from "assets/icons/plus.svg";
import ShiftForm from "./ShiftForm";
import AppRadio from "components/Input/AppRadio";
// import AppSelect from "components/Select/AppSelect";
// import { BOOKING_STATUS } from "config/AppConfig";
import { useMedia } from "react-use";



const BookingWorkerModal = (props) => {
  const {
    jobId,
    jobDetail,
    onAddShift,
    loadJob,
    jobAvailabilities,
    selectedWeek,
    setSelectedWeek,
    week: weekOnJobCalendar,
    yearJobCalendar,
    dayOfWeek,
    shiftType,
    shiftId,
    setShiftId,
    setShiftType,
    setDayOfWeek,
    setReload,
    reload,
  } = props;
  const below768 = useMedia("(max-width: 767.2px)");
 
  console.log('jobDetail', jobDetail);
  const styles = makeStyles(() => ({
    radio: {},
    large: {
      width: "3rem",
      height: "3rem",
    },
    dateList: {
      display: "flex",
      margin: "2rem 0 1rem 0",
      justifyContent: "center",
      flexWrap: below768 ? 'wrap' : 'nowrap'
    },
    shiftList: {
      display: "flex",
      margin: "0 0 1rem 0",
      justifyContent: "center",
      flexWrap: below768 ? 'wrap' : 'nowrap'
    },
    dateItem: {
      padding: "0.5rem",
      border: "1px solid rgba(0, 0, 0, 0.2)",
      borderRadius: 4,
      cursor: "pointer",
    },
    activeDate: {
      backgroundColor: AppColor.mainBlue,
      color: AppColor.white,
      boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
      border: "none",
    },
    shiftItem: {
      padding: "0.5rem",
      fontSize: "0.8rem",
      fontWeight: 700,
      display: "flex",
      alignItems: "center",
      opacity: 0.4,
      cursor: "pointer",
    },
    activeShift: {
      border: "none",
      opacity: 1,
    },
    boxCalendar: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      margin: "0.5rem 0",
      "& i": {
        cursor: "pointer",
      },
      "& span": {
        cursor: "pointer",
      },
    },
    disabled: {
      opacity: 0.5,
      pointerEvents: "none",
    },
    disabledDate: {
      opacity: 0.4,
      pointerEvents: "none",
      background: "#e5e5e5",
    },
    weeks: {
      display: "flex",
      flexDirection: "column",
      border: "1px solid rgba(0, 0, 0, 0.2)",
      boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
      position: "absolute",
      width: "100%",
      background: AppColor.white,
      left: 0,
      zIndex: 100,
      textAlign: "center",
      "& span": {
        margin: "0.3rem",
      },
    },
    plusIcon: {
      marginLeft: "0.5rem",
      cursor: "pointer",
      width: 30,
    },
    plusSmallIcon: {
      marginLeft: "0.5rem",
      cursor: "pointer",
    },
    wrapEstimate: {
      border: "1px solid rgba(0, 0, 0, 0.2)",
      boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
      borderRadius: 4,
      padding: "0.5rem",
      margin: "0.5rem 0",
      display: "flex",
      maxWidth: 550,
      flex: "1 0 0px",
    },
    bold: {
      fontWeight: 700,
    },
    control: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "1rem",
    },
    listTitle: {
      fontSize: "16px",
      color: AppColor.black,
      fontWeight: "500",
      padding: 0,
      margin: 0,
    },
    select: {
      width: "100%",
    },
  }));
  const { t } = useTranslation();
  const classes = styles();
  const dispatch = useDispatch();
  const isMobile = AppUtil.mobileAndTabletCheck();

  const [showOptionBooking, setShowOptionBooking] = useState(false);
  const [showListWeek, setShowListWeek] = useState(false);
  const [showAddShift, setShowAddShift] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isGettingData, setIsGettingData] = useState(false);

  const [workers, setWorkers] = useState([]);
  const [calendar, setCalendar] = useState([]);
  const [shiftData, setShiftData] = useState({});
  const [dateList, setDateList] = useState([]);
  const [validDateList, setValidDateList] = useState([]);

  const [jobAvailabilitiesFillter, setJobAvailabilitiesFillter] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayOfWeek);
  const [selectedShift, setSelectedShift] = useState(shiftType);
  const [selectedWorker, setSelectedWorker] = useState();
  const [selectedJobAvailabilityId, setSelectedJobAvailabilityId] = useState();
  const [estimate, setEstimate] = useState(null);
  const [newShift, setNewShift] = useState({});

  const [queries, setQueries] = useState({
    search_key: "",
  });

  const { specialtyId, supportId, accreditationId } = jobDetail;
  const startDate = moment
    .utc(jobDetail.startDate)
    .local()
    .format("YYYY-MM-DD");
  const endDate = moment.utc(jobDetail.endDate).local().format("YYYY-MM-DD");


  const _loadData = async ({ search_key } = {}) => {
    if (!selectedDate || !selectedJobAvailabilityId) {
      setTimeout(() => {
        setIsGettingData(false);
      }, 1000);
      return;
    }

    setIsGettingData(true);

    const selectedWeekData = calendar.find(
      (week) => week.weekNum === selectedWeek.week && week.year === selectedWeek.year
    );

    if (!selectedWeekData) {
      setIsGettingData(false);
      return;
    }

    const newQueries = {
      ...queries,
    };

    const weekNum = selectedWeekData.weekNum;
    const year = selectedWeekData.year;

    newQueries.jobAvailabilityId = selectedJobAvailabilityId;
    newQueries.date = moment()
      .isoWeek(weekNum)
      .isoWeekYear(year)
      .isoWeekday(selectedDate)
      .format('YYYY/MM/DD');

    newQueries.search_key = search_key || "";

    const result = await dispatch(
      getWorkerToBooking({ ...newQueries, jobId: jobId })
    );

    const { payload } = result;
    console.log("payload", payload);
    setWorkers(payload);
    setQueries(newQueries);
    setTimeout(() => {
      setIsGettingData(false);
    }, 1000);
  };

  const isApplyTime = (monday, sunday, timeApply) => {
    const applyStartDate = moment.utc(timeApply.applyStartDate);
    const applyEndDate = moment.utc(timeApply.applyEndDate);
    return (
      applyEndDate.isSameOrAfter(monday) &&
      applyStartDate.isSameOrBefore(sunday)
    );
  };

  const isBeforeCurrentShift = () => {
    if (!selectedWeek || !selectedDate || !selectedWeek.year) {
      return false;
    }

    const selectedWeekData = calendar.find(
      week => week.weekNum === selectedWeek.week &&
        week.year === selectedWeek.year
    );

    if (!selectedWeekData) {
      return false;
    }
    return false;
  };

  const DAYS_OF_WEEK_S = {
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    SUNDAY: 7,
  };

  const isBeforeToday = (date) => {


    const selectedWeekData = calendar.find(
      week => week.weekNum === selectedWeek?.week &&
        week.year === selectedWeek?.year
    );


    if (!selectedWeekData) {
      return false;
    }

    const dayIndex = DAYS_OF_WEEK_S[date];
    if (!dayIndex) {
      return false;
    }

    const currentDay = moment(selectedWeekData.firstWeekDay)
      .add(dayIndex - 1, 'days');
    return currentDay.isBefore(moment().startOf('day'));
  };

  const getEstimate = async (data) => {
    try {
      const { workerResponse: { yearsOfExperience: yearExp } } = data;
      if (!selectedWeek?.week || !selectedDate || !selectedJobAvailabilityId) {
        return;
      }

      const selectedWeekData = calendar.find(
        week => week.weekNum === selectedWeek.week &&
          week.year === selectedWeek.year
      );
      if (!selectedWeekData) {
        return;
      }

      const jobAvailability = jobAvailabilities.find(
        item => String(item.id) === String(selectedJobAvailabilityId)
      );
      if (!jobAvailability) {
        return;
      }

      const hours = moment(jobAvailability.endTime)
        .diff(moment(jobAvailability.startTime), "hours", true);

      const dayNumber = getNumberByDayOfWeek(selectedDate); 
      const firstDayLocal = moment.utc(selectedWeekData.firstWeekDay).local(); 
      const workDate = firstDayLocal
        .add(dayNumber - 1, 'days')
        .format("YYYY/MM/DD");

      const params = {
        availabilities: [{
          date: workDate,
          hours: hours,
          shift: selectedShift,
        }],
        yearsOfExperience: yearExp,
        jobAvailabilityId: selectedJobAvailabilityId,
      };

      const optionalParams = {
        specialtyId,
        supportId,
        accreditationId
      };

      Object.entries(optionalParams).forEach(([key, value]) => {
        if (value) {
          params[key] = value;
        }
      });

      const { payload } = await dispatch(reduceCalculatePrice(params));

      if (payload) {
        setShowOptionBooking(true);
        setEstimate(payload);
      } else {
        setEstimate(null);
        setShowOptionBooking(false);
      }
    } catch (error) {
      console.error('Error calculating estimate:', error);
      setEstimate(null);
      setShowOptionBooking(false);
    }
  };

  const getNumberByDayOfWeek = (shiftType) => {
    switch (shiftType) {
      case "MONDAY":
        return 1;
      case "TUESDAY":
        return 2;
      case "WEDNESDAY":
        return 3;
      case "THURSDAY":
        return 4;
      case "FRIDAY":
        return 5;
      case "SATURDAY":
        return 6;
      case "SUNDAY":
        return 7;
      default:
        return 0;
    }
  };

  const checkValidDate = (
    date,
    weekNumber = selectedWeek?.week,
    year = selectedWeek?.year
  ) => {
    const selectedWeek = calendar.find(
      week => week.weekNum === weekNumber && week.year === year
    );

    if (!selectedWeek) {
      return false;
    }

    const weekNum = selectedWeek.weekNum;

    const currentDay = moment()
      .isoWeekYear(year)
      .isoWeek(weekNum)
      .isoWeekday(date);

    if (
      currentDay.isBefore(moment(startDate).hours(0).minutes(0)) ||
      currentDay.isAfter(moment(endDate).hours(23).minutes(59))
    ) {
      return false;
    }

    return true;
  };

  const checkIsFullDayOfWeek = (date) => {
    if (!selectedWeek?.week || !selectedWeek?.year) {
      return false;
    }

    const selectedWeekData = calendar.find(
      week => week.weekNum === selectedWeek.week &&
        week.year === selectedWeek.year
    );

    if (!selectedWeekData) {
      return false;
    }

    const currentDay = moment()
      .isoWeekYear(selectedWeek.year)
      .isoWeek(selectedWeekData.weekNum)
      .isoWeekday(date);

    if (
      currentDay.isBefore(moment(startDate).hours(0).minutes(0)) ||
      currentDay.isAfter(moment(endDate).hours(23).minutes(59))
    ) {
      return false;
    }

    return true;
  };

  const getWeekDates = (year, weekNumber) => {
    let firstWeekDay = moment().isoWeekYear(year).isoWeek(weekNumber).startOf('isoWeek');
    let lastWeekDay = moment().isoWeekYear(year).isoWeek(weekNumber).endOf('isoWeek');

    return {
      firstWeekDay,
      lastWeekDay,
      weekNum: weekNumber,
      year: year
    };
  };

  const generateWeeks = () => {
    const monthRange = moment.range(startDate, endDate);
    let weeks = [];
    let years = new Set();

    for (const mday of monthRange.by("days")) {
      const weekYear = {
        week: mday.isoWeek(),
        year: mday.isoWeekYear()
      };

      const weekYearKey = `${weekYear.year}-${weekYear.week}`;
      if (!weeks.find(w => `${w.year}-${w.week}` === weekYearKey)) {
        weeks.push(weekYear);
        years.add(weekYear.year);
      }
    }

    weeks.sort((a, b) => {
      if (a.year !== b.year) {
        return a.year - b.year;
      }
      return a.week - b.week;
    });

    let calendarArr = [];

    for (const weekData of weeks) {
      calendarArr.push(getWeekDates(weekData.year, weekData.week));
    }
    const currentWeekYear = moment().isoWeekYear();
    const currentWeekNum = moment().isoWeek();
    console.log('weeks', weeks);
    const currentWeekIndex = weekOnJobCalendar
      ? weeks.findIndex(w => w.week === weekOnJobCalendar && w.year === yearJobCalendar)
      : weeks.findIndex(w => w.week === currentWeekNum && w.year === currentWeekYear);

    let newWeek = {
      firstWeekDay: calendarArr[
        currentWeekIndex !== -1 ? currentWeekIndex : 0
      ].lastWeekDay,
      week: currentWeekIndex !== -1 ? weeks[currentWeekIndex].week : weeks[0].week,
      year: calendarArr[
        currentWeekIndex !== -1 ? currentWeekIndex : 0
      ].lastWeekDay.year()
    };

    if (
      selectedWeek &&
      (selectedWeek.week || selectedWeek.week === 0) &&
      selectedWeek.year
    ) {
      newWeek = { ...selectedWeek };
    }

    if (calendarArr.length > 0) {
      return {
        newCalendar: calendarArr,
        newWeek,
      };
    }



    return null;
  };

  const generateShift = (calendarArr, weekNumber, year) => {
    if (
      !calendarArr ||
      calendarArr.length === 0 ||
      !jobAvailabilities ||
      (!weekNumber && weekNumber !== 0) ||
      (!year && year !== 0)
    ) {
      return;
    }

    const selectedWeek = calendarArr.find(
      week => week.weekNum === weekNumber && week.year === year
    );

    if (!selectedWeek) {
      return;
    }

    let shiftObj = {};
    let dateArr = [];
    let validDateArr = [];

    for (const date of DAYS_OF_WEEK) {
      shiftObj[date] = [];
    }

    for (const item of jobAvailabilities) {
      const isApply = isApplyTime(
        moment(selectedWeek.firstWeekDay),
        moment(selectedWeek.lastWeekDay),
        item
      );

      if (isApply) {
        const { dayOfWeek, shiftType } = item;
        shiftObj[dayOfWeek] = [...new Set([...shiftObj[dayOfWeek], shiftType])];
        dateArr = [...dateArr, dayOfWeek];

        const isValidDate = checkValidDate(dayOfWeek, weekNumber, year);
        if (isValidDate) {
          validDateArr = [...validDateArr, dayOfWeek];
        }
      }
    }

    const newValidDateList = [...new Set(validDateArr)].sort((a, b) =>
      getNumberByDayOfWeek(a) < getNumberByDayOfWeek(b) ? -1 : 1
    );

    return {
      newShiftData: shiftObj,
      newDateList: [...new Set(dateArr)],
      newValidDateList: newValidDateList,
    };
  };

  const onChangeWeek = (weekNum, nextYear, backYear) => {
    if (!calendar || calendar.length === 0) {
      console.error("Calendar is empty or undefined.");
      return;
    }
    const currentWeekData = calendar.find(
      (week) => nextYear ?
        week.weekNum === weekNum && week.year === selectedWeek.year + 1
        : backYear ?
            week.weekNum === weekNum && week.year === selectedWeek.year - 1
            : week.weekNum === weekNum && week.year === selectedWeek.year
    );

    if (!currentWeekData) {
      console.error(`Week number ${weekNum} not found in calendar.`);
      return;
    }

    setSelectedWeek({
      week: weekNum,
      year: currentWeekData.year,
      firstWeekDay: currentWeekData.firstWeekDay,
      lastWeekDay: currentWeekData.lastWeekDay,
    });
  };
  const onSelectWeek = (weekSelect) => {
    if (!calendar || calendar.length === 0) {
      console.error("Calendar is empty or undefined.");
      return;
    }

    const selectData = calendar.find(weekCalendar => weekCalendar.weekNum === weekSelect.week && weekCalendar.year === weekSelect.year);
    setSelectedWeek({
      week: selectData.weekNum,
      year: selectData.year,
    })
    setShowListWeek(false);
  }

  const onChangeDate = (date) => {
    if (setShiftId) {
      setShiftId();
    }
    setSelectedDate(date);
  };

  const onChangeShift = (shift) => {
    setSelectedShift(shift);
  };

  const onClickBookWorker = (data) => {
    setSelectedWorker(data);
    getEstimate(data);
  };

  const handleSearchWorker = async (searchText) => {
    if (selectedJobAvailabilityId) {
      await _loadData({ search_key: searchText });
    } else {
      setWorkers([]);
    }
  };

  const handleBookWorker = async ({
    workerId,
    scheduleId,
    specialtyId,
    supportId,
  }) => {
    if (!selectedWeek) {
      return;
    }
    setIsLoading(true);

    const selectedWeekData = calendar.find(
      (week) => week.weekNum === selectedWeek.week && week.year === selectedWeek.year
    );

    if (!selectedWeekData) {
      console.error("Calendar not found:", selectedWeek);
      setIsLoading(false);
      return;
    }

    // Lấy thông tin jobAvailability
    const jobAvailability = jobAvailabilities.find(
      (value) => String(value.id) === String(selectedJobAvailabilityId)
    );

    if (!jobAvailability) {
      setIsLoading(false);
      return;
    }

    const momentStartTime = moment(jobAvailability.startTime);
    const momentEndTime = moment(jobAvailability.endTime);

    const dayNumber = getNumberByDayOfWeek(selectedDate);

    let startTime = moment(selectedWeekData.firstWeekDay)
      .add(dayNumber - 1, 'days')
      .hours(momentStartTime.hours())
      .minutes(momentStartTime.minutes())
      .seconds(0)
      .milliseconds(0);

    let endTime = moment(selectedWeekData.firstWeekDay)
      .add(dayNumber - 1, 'days')
      .hours(momentEndTime.hours())
      .minutes(momentEndTime.minutes())
      .seconds(0)
      .milliseconds(0);

    if (moment.range(startTime, endTime).diff("minutes") <= 0) {
      endTime.add(1, "days");
    }

    const params = {
      isBooking: true,
      jobId: jobId,
      scheduleId: scheduleId,
      specialtyId: specialtyId,
      supportId: supportId,
      jobAvailabilityId: selectedJobAvailabilityId,
      startTime: startTime.format("yyyy/MM/DD HH:mm"),
      endTime: endTime.format("yyyy/MM/DD HH:mm"),
      workerId: workerId,
    };

    await dispatch(bookWorkerForJob(params));

    setShowOptionBooking(false);
    loadJob();
    setReload && setReload(true);
    setIsLoading(false);
  };

  const handleAddShift = async (data) => {
    setIsLoading(true);
    await onAddShift(data);
    setIsLoading(false);
    setShowAddShift(false);
  };

  //CHECK
  const handleSelectedDate = (dates) => {
    const validDates = dates.filter((item) => !isBeforeToday(item)) || [];
    return validDates;
  };
  const handleChangeRadio = (event) => {
    setShiftId && setShiftId();
    setShiftType && setShiftType();
    setSelectedJobAvailabilityId(Number(event.target.value));
  };
  const handleIconNextChange = () => {
    if (!selectedWeek || (selectedWeek.week === calendar[calendar.length - 1].weekNum && selectedWeek.year === calendar[calendar.length - 1].year)) {
      return;
    }
    if (selectedWeek.week === 52) {
      const currentWeekIndex = calendar.findIndex(weekCalendar => weekCalendar.weekNum === selectedWeek.week && weekCalendar.year === selectedWeek.year);
      onChangeWeek(calendar[currentWeekIndex + 1].weekNum, true, false);
    } else {
      onChangeWeek(selectedWeek.week + 1);
    }
    setIsGettingData(true);
    setSelectedDate(); // Clear selected date
  };

  const handleIconPreviousChange = () => {
    if (!selectedWeek || selectedWeek.week <= 0) {
      return;
    }
    if (selectedWeek.week === 1) {
      const currentWeekIndex = calendar.findIndex(weekCalendar => weekCalendar.weekNum === selectedWeek.week && weekCalendar.year === selectedWeek.year);
      onChangeWeek(calendar[currentWeekIndex - 1].weekNum, false, true);
    } else {
      onChangeWeek(selectedWeek.week - 1);
    }
    setIsGettingData(true);
    setSelectedDate(); // Clear selected date
  };


  const handleRenderTime = (data) => {
    return `${data.booking.date} ${t(
      `shift.${data.booking.shiftType}`
    )}, ${moment(`${data.booking.startTime}`).format("HH:mm")} - ${moment(
      `${data.booking.endTime}`
    ).format("HH:mm")}`;
  };

  // isBooking
  const confirmBookWorker = () => {
    const params = {
      workerId: selectedWorker.workerResponse.id,
      scheduleId: selectedWorker.schedule.id,
    };
    if (specialtyId) {
      params["specialtyId"] = specialtyId;
    }
    if (supportId) {
      params["supportId"] = supportId;
    }
    handleBookWorker(params);
  };

  const renderShiftIcon = (shift) => {
    let iconComponent;
    switch (shift) {
      case "MORNING":
        iconComponent = MorningIcon;
        break;
      case "AFTERNOON":
        iconComponent = AfternoonIcon;
        break;
      case "EVENING":
        iconComponent = EveningIcon;
        break;
      case "NIGHT":
        iconComponent = NightIcon;
        break;
      default:
        iconComponent = MorningIcon;
        break;
    }
    return (
      <img
        src={iconComponent}
        className={classNames({
          [classes.itemIcon]: true,
        })}
      />
    );
  };

  const renderSelectedWeek = () => {
    if (!selectedWeek) {
      return null;
    }

    const weekData = calendar.find(week =>
      week.weekNum === selectedWeek.week &&
      week.year === selectedWeek.year
    ) || {};

    const { firstWeekDay, lastWeekDay } = weekData;

    return (
      <Box style={{ position: "relative", padding: "0 1rem" }}>
        {showListWeek && (
          <ClickAwayListener onClickAway={() => setShowListWeek(false)}>
            <Box className={classes.weeks}>
              {calendar.map((item, index) => {
                const {
                  firstWeekDay: fstWeekDay,
                  lastWeekDay: lstWeekDay,
                  weekNum,
                  year
                } = item;
                return (
                  <span
                    key={`calendar-${index}`}
                    onClick={() =>
                      selectedWeek &&
                      (selectedWeek.week !== weekNum || selectedWeek.year !== year) &&
                      onSelectWeek({
                        week: weekNum,
                        year: year
                      })
                    }
                  >{`${fstWeekDay ? fstWeekDay.format("DD/MM") : ""} - ${lstWeekDay ? lstWeekDay.format("DD/MM") : ""
                    }`}</span>
                );
              })}
            </Box>
          </ClickAwayListener>
        )}
        <span onClick={() => setShowListWeek(true)}>{`${firstWeekDay ? firstWeekDay.format("DD/MM") : ""
          } - ${lastWeekDay ? lastWeekDay.format("DD/MM") : ""}`}</span>
      </Box>
    );
  };

  useEffect(() => {
    var newWeek = {};
    var newCalendar = [];
    const objCalendar = generateWeeks();
    if (objCalendar) {
      newCalendar = objCalendar.newCalendar;
      newWeek = objCalendar.newWeek;
    }
    setCalendar(newCalendar);
    setSelectedWeek(newWeek);
  }, []);

  useEffect(() => {
    if (
      calendar &&
      calendar.length > 0 &&
      jobAvailabilities &&
      jobAvailabilities.length > 0 &&
      selectedWeek &&
      (selectedWeek.week || selectedWeek.week === 0) &&
      selectedWeek.year
    ) {
      const { newDateList, newValidDateList, newShiftData } = generateShift(
        calendar,
        selectedWeek.week,
        selectedWeek.year
      );

      setDateList(newDateList);
      setShiftData(newShiftData);
      setValidDateList(newValidDateList);
    }
  }, [calendar, selectedWeek, jobAvailabilities]);

  useEffect(() => {
    if (validDateList && validDateList.length > 0) {
      const validList = handleSelectedDate(validDateList);
      // check selectedDate is not in this validList
      if (validList.indexOf(selectedDate) < 0) {
        setSelectedDate(validList[0]);
      }
    } else {
      setWorkers([]);
    }
  }, [validDateList]);

  useEffect(() => {
    if (shiftData && selectedDate) {
      if (selectedWeek && (selectedWeek.week === 0 || selectedWeek.week)) {
        setSelectedShift(shiftData[selectedDate][0]);
      } else {
        if (!dayOfWeek) {
          setSelectedShift(shiftData[selectedDate][0]);
        }
      }
    }
  }, [selectedDate]);

  // set jobAvailabilitiesFillter when selectedWeek or selectedShift
  // or selectedDate  or jobAvailabilities  change
  useEffect(() => {
    if (
      selectedShift &&
      selectedDate &&
      jobAvailabilities &&
      calendar.length > 0 &&
      (selectedWeek?.week || selectedWeek?.week === 0) &&
      selectedWeek?.year
    ) {
      const now = moment().add(30, "minutes");
      const selectedWeekData = calendar.find(
        (week) => week.weekNum === selectedWeek.week && week.year === selectedWeek.year
      );

      if (!selectedWeekData) {
        console.error("Calendar not found:", selectedWeek);
        setJobAvailabilitiesFillter([]);
        return;
      }

      let newValue = jobAvailabilities
        .filter((value) => {
          const selectedWeekData = calendar.find(
            (week) => week.weekNum === selectedWeek.week && week.year === selectedWeek.year
          );

          if (!selectedWeekData) {
            console.error("Calendar not found:", selectedWeek);
            return false;
          }

          const isApply = isApplyTime(
            moment(selectedWeekData.firstWeekDay),
            moment(selectedWeekData.lastWeekDay),
            value
          );

          const nowDate = moment().startOf("day");
          const applyEndDate = moment(value.applyEndDate);
          const isFutureOrToday = applyEndDate.isSameOrAfter(nowDate);

          return (
            value.dayOfWeek === selectedDate &&
            value.shiftType === selectedShift &&
            isApply &&
            isFutureOrToday
          );
        })
        .map((value) => {
          let isDisable = false;
          const selectedWeekData = calendar.find(
            (week) => week.weekNum === selectedWeek.week && week.year === selectedWeek.year
          );

          if (!selectedWeekData) {
            console.error("Calendar not found:", selectedWeek);
            return { ...value, isDisable: true };
          }

          const weekNum = selectedWeekData.weekNum;
          const currentDay = moment()
            .isoWeekYear(selectedWeek.year)
            .isoWeek(weekNum)
            .isoWeekday(selectedDate)
            .format("YYYY/MM/DD");

          const momentStartTime = moment(currentDay)
            .hours(moment(value.startTime).hours())
            .minutes(moment(value.startTime).minutes());

          if (moment.range(momentStartTime, now).diff("minutes") >= 0) {
            isDisable = true;
          }

          return { ...value, isDisable };
        });

      //CHECK setJobAvailabilitiesFillter
      const filterShifts = newValue.map(shift => {
                const monday = moment(selectedWeekData.firstWeekDay).format('YYYY/MM/DD HH:mm');
                const sunday = moment(selectedWeekData.lastWeekDay).format('YYYY/MM/DD HH:mm');
                const startTime = moment(shift.applyStartDate).utc().format('YYYY/MM/DD HH:mm');
                const endTime = moment(shift.applyEndDate).utc().format('YYYY/MM/DD HH:mm');
                if (moment(endTime).isSameOrAfter(moment(monday)) && moment(startTime).isSameOrBefore(moment(sunday))) {
                  return { ...shift };
                }
      }).filter(item => (item !== undefined || item !== null) && item);

      setJobAvailabilitiesFillter([...filterShifts]);
    } else {
      if (isGettingData) {
        setTimeout(() => {
          setIsGettingData(false);
        }, 1500);
      }
    }
  }, [selectedShift, selectedDate, jobAvailabilities, calendar, selectedWeek]);

  // CHECK RADIO
  // Set SelectedJobAvailabilityId When jobAvailabilitiesFillter Change
  useEffect(() => {
    if (jobAvailabilitiesFillter.length > 0) {
      const jobAvailabilitiesFindSelected = jobAvailabilitiesFillter.find(
        (value) =>
          !value.isDisable && value.id === Number(selectedJobAvailabilityId)
      );
      var jobAvailabilitiesFindIsDisable = jobAvailabilitiesFillter.find(
        (value) => !value.isDisable && value.shiftType === selectedShift
      );
      if (jobAvailabilitiesFindSelected) {
        jobAvailabilitiesFindIsDisable = jobAvailabilitiesFindSelected;
      }
      if (jobAvailabilitiesFindIsDisable) {
        if (jobAvailabilitiesFindIsDisable.id === selectedJobAvailabilityId) {
          _loadData(queries);
        }
        const isValidShift = jobAvailabilitiesFillter.find(
          (value) => !value.isDisable && value.id === Number(shiftId)
        );
        setSelectedJobAvailabilityId(
          shiftId && !selectedJobAvailabilityId
            ? shiftId !== jobAvailabilitiesFindIsDisable.id && isValidShift
              ? shiftId
              : jobAvailabilitiesFindIsDisable.id
            : jobAvailabilitiesFindIsDisable.id
        );
        setShiftId && setShiftId();
        setShiftType && setShiftType();
        setDayOfWeek && setDayOfWeek();
        setTimeout(() => {
          setIsGettingData(false);
        }, 1000);
      } else {
        setSelectedJobAvailabilityId(undefined);
        setTimeout(() => {
          setIsGettingData(false);
        }, 1000);
      }
    }
  }, [jobAvailabilitiesFillter]);

  // load Workers when selectedJobAvailabilityId change
  useEffect(() => {
    if (selectedJobAvailabilityId) {
      // setShiftId && setShiftId();
      // setShiftType && setShiftType();
      // setDayOfWeek && setDayOfWeek();
      _loadData(queries);
    } else {
      setWorkers([]);
    }
  }, [selectedJobAvailabilityId]);

  useEffect(() => {
    if (workers.length > 0 && !selectedJobAvailabilityId) {
      setWorkers([]);
    }
  }, [workers]);

  useEffect(() => {
    if (reload) {
      _loadData(queries);
      setReload && setReload(false);
    }
  }, [reload]);

  console.log("queries", queries);

  return (
    <Box>
      <InputSearch
        onSearch={handleSearchWorker}
        onSearching={handleSearchWorker}
        fullWidth
      />
      <Box className={classes.boxCalendar}>
        <i
          className={`fas fa-chevron-left mr-1 ${!selectedWeek || selectedWeek.week <= 0 ? classes.disabled : ""
            }`}
          onClick={handleIconPreviousChange}
        ></i>
        {renderSelectedWeek()}
        <i
          className={`fas fa-chevron-right ml-1 ${selectedWeek && calendar.length && selectedWeek.week === calendar[calendar.length - 1].weekNum && selectedWeek.year === calendar[calendar.length - 1].year
              ? classes.disabled
              : ""
            }`}
          onClick={handleIconNextChange}
        ></i>
      </Box>
      <Box className={classes.dateList}>
        {!isMobile ? (
          validDateList.map((item, index) => {
            if (shiftData[item].length > 0) {
              return (
                <Box
                  key={`date-${index}`}
                  className={classNames({
                    [classes.dateItem]: true,
                    [classes.activeDate]: item === selectedDate,
                    [classes.disabledDate]: isBeforeToday(item),
                  })}
                  onClick={() => onChangeDate(item)}
                >
                  {t(`daysOfTheWeek.${item}`)}
                </Box>
              );
            }
          })
        ) : validDateList.map((item, index) => {
          if (shiftData[item].length > 0) {
            return (
              <Box
                key={`date-${index}`}
                className={classNames({
                  [classes.dateItem]: true,
                  [classes.activeDate]: item === selectedDate,
                  [classes.disabledDate]: isBeforeToday(item),
                })}
                onClick={() => onChangeDate(item)}
              >
                {t(`daysOfTheWeek.${item}`)}
              </Box>
            );
          }
        })}
        {selectedWeek &&
          (selectedWeek.week || selectedWeek.week === 0) &&
          calendar.length > 0 &&
          dateList.length < 7 &&
          DAYS_OF_WEEK.filter(
            (day) => !validDateList.includes(day) && checkIsFullDayOfWeek(day)
          ).length > 0 && (
            <img
              src={PlusIcon}
              className={classNames({
                [classes.plusIcon]: true,
                [classes.disabled]: jobDetail.client?.status === "DEACTIVATE",
              })}
              onClick={() => {
                if (jobDetail.client?.status === "DEACTIVATE") return;
                setNewShift({
                  ignoreDay: validDateList,
                });
                setShowAddShift(true);
              }}
            />
          )}
      </Box>
      {isGettingData ? (
        <Box
          style={{
            height: 350,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <LinearProgress />
        </Box>
      ) : (
        <>
          <Box className={classes.shiftList}>
            {shiftData[selectedDate] &&
              shiftData[selectedDate].map((item, index) => {
                return (
                  <Box
                    key={`shift-${index}`}
                    className={classNames({
                      [classes.shiftItem]: true,
                      [classes.activeShift]: item === selectedShift,
                      [classes.disabledDate]: isBeforeCurrentShift(),
                    })}
                    onClick={() => onChangeShift(item)}
                  >
                    {renderShiftIcon(item)}
                    {t(`shift.${item}`)}
                  </Box>
                );
              })}
            {shiftData[selectedDate] && (
              <img
                src={PlusIcon}
                className={classNames({
                  [classes.plusSmallIcon]: true,
                  [classes.disabled]: jobDetail.client?.status === "DEACTIVATE",
                })}
                onClick={() => {
                  if (jobDetail.client?.status === "DEACTIVATE") return;
                  setNewShift({
                    dayOfWeek: selectedDate ? selectedDate : "",
                    ignoreShift: shiftData[selectedDate],
                  });
                  setShowAddShift(true);
                }}
              />
            )}
          </Box>
          {selectedDate && selectedShift && jobAvailabilitiesFillter && (
            <RadioGroup
              row
              aria-label="position"
              name="jobAvailabilities"
              onChange={handleChangeRadio}
              className={classes.radioGroup}
              style={{ display: "flex" }}
            >
              {jobAvailabilitiesFillter.map((value) => {
                return (
                  <FormControlLabel
                    key={value.id}
                    style={{ margin: "0 5px" }}
                    checked={
                      String(selectedJobAvailabilityId) === String(value.id)
                    }
                    value={value.id}
                    disabled={value.isDisable}
                    label={
                      moment(value.startTime).format("HH:mm - ") +
                      moment(value.endTime).format("HH:mm")
                    }
                    control={<AppRadio />}
                    className={classes.radio}
                  />
                );
              })}
            </RadioGroup>
          )}
          {!!selectedDate && !!selectedShift && workers && (
            <Box>
              {workers.map((item, index) => {
                if (
                  (item.booking && item.booking.bookingStatus !== "DONE") ||
                  (!item.booking && !item.booked)
                ) {
                  return (
                    <JobUserTag
                      key={`worker-${index}`}
                      isDisableButtonBook={
                        selectedJobAvailabilityId ? false : true
                      }
                      isDisable={jobDetail.client?.status === "DEACTIVATE"}
                      userInfo={{
                        ...item.workerResponse,
                        bookingStatus:
                          item.booking && item.booking.bookingStatus,
                        booked: item.booked,
                        bookingId: item.booking && item.booking.id,
                        time: item.booking ? handleRenderTime(item) : "",
                      }}
                      onAdd={() => onClickBookWorker(item)}
                      isBooking={
                        item.booking &&
                          item.booking.bookingStatus !== "AVAILABLE" &&
                          item.workerResponse.id
                          ? false
                          : true
                      }
                      isCancel={
                        item.booking &&
                          item.booking.bookingStatus !== "AVAILABLE" &&
                          item.booking.bookingStatus !== "CANCEL" &&
                          item.booking.bookingStatus !== "DONE" &&
                          item.booking.bookingStatus !== "ON_GOING" &&
                          item.booking.bookingStatus !== "NO_CLOCK_IN" &&
                          item.workerResponse.id
                          ? true
                          : false
                      }
                      isEndBooking={
                        ((item.booking &&
                          item.booking.bookingStatus === "ON_GOING") ||
                          (item.booking &&
                            item.booking.bookingStatus === "NO_CLOCK_IN")) &&
                          item.workerResponse.id
                          ? true
                          : false
                      }
                      setReload={setReload}
                      bookingInfo={item.booking ? item.booking : null}
                      isBookingPopup={true}
                    />
                  );
                }
              })}
            </Box>
          )}
        </>
      )}

      <AppDialog
        open={showOptionBooking}
        onClose={() => {
          setShowOptionBooking(false);
          // setShowConfirmBookWorker(false);
        }}
        // maxWidth={showConfirmBookWorker ? "xs" : "sm"}
        maxWidth={"sm"}
        title={t("title.estimatedPrice")}
      >
        {estimate && (
          <Box>
            <Box>
              {!isMobile ?
                <Box display="flex" justifyContent="center">
                  <Box className={classes.wrapEstimate}>
                    <Box flex="3 0 0px">
                      <Box className="mb-4">{t("label.time")}</Box>
                      <Box>
                        {estimate.dayTypes &&
                          estimate.dayTypes.map((item, index) => {
                            if (index > 0) {
                              return null;
                            }
                            return (
                              <Box
                                key={`day-type-${index}`}
                                style={{ width: "calc(100% + 150px)" }}
                              >
                                <Box className={classes.bold}>
                                  {t(`dayType.${item.dayType}`)}
                                </Box>
                                <Box className="ml-4">
                                  {item.shifts &&
                                    item.shifts.map(
                                      (estimateShift, indexShift) => {
                                        var totalPrice = 0;
                                        var price = 0;
                                        var totalHours = 0;
                                        var shiftType = estimateShift.shiftType;
                                        if (
                                          estimateShift.rate ||
                                          estimateShift.rate === 0
                                        ) {
                                          totalPrice =
                                            estimateShift.rate *
                                            estimateShift.totalHours;
                                          totalHours = estimateShift.totalHours;
                                          price = estimateShift.rate;
                                        } else {
                                          totalPrice = estimateShift.segmentPrice
                                            ? estimateShift.segmentPrice
                                            : estimateShift.remainingPrice
                                              ? estimateShift.remainingPrice
                                              : 0;
                                          totalHours = estimateShift.segmentHours
                                            ? estimateShift.segmentHours
                                            : estimateShift.remainingHours
                                              ? estimateShift.remainingHours
                                              : 0;
                                          price = estimateShift.segmentRateHours
                                            ? estimateShift.segmentRateHours
                                            : estimateShift.mainRateHours;
                                        }
                                        return (
                                          <Grid
                                            container
                                            key={`estimate-shift-${indexShift}`}
                                            spacing={2}
                                          >
                                            <Grid item xs={6}>
                                              <span>{` ${t(
                                                `shift.${shiftType}`
                                              )} (${totalHours} hours): `}</span>
                                            </Grid>
                                            <Grid item xs={6}>
                                              <span>{`$${AppUtil.formatMoney(
                                                totalPrice.toFixed(2)
                                              )} `}</span>
                                              {isMobile ? <br /> : <></>}
                                              <span>{`($${AppUtil.formatMoney(
                                                price.toFixed(2)
                                              )}/hour)`}</span>
                                            </Grid>
                                          </Grid>
                                        );
                                      }
                                    )}
                                </Box>
                              </Box>
                            );
                          })}
                      </Box>
                    </Box>
                    <Box flex="1 0 0px">
                      <Box>{t("label.total")}</Box>
                      <Box className={classes.bold}>{`$${AppUtil.formatMoney(
                        estimate.totalPrice.toFixed(2)
                      )}`}</Box>
                    </Box>
                  </Box>
                </Box>
              : <Grid container>
                <Grid item xs={6}>
                {t("label.time")}
                </Grid>
                <Grid item xs={6}>
                {t("label.total")}
                </Grid>
                <Grid item xs={12}>
                <Box>
                        {estimate.dayTypes &&
                          estimate.dayTypes.map((item, index) => {
                            if (index > 0) {
                              return null;
                            }
                            return (
                              <Box
                                key={`day-type-${index}`}
                                style={{}}
                              >
                                <Box className={classes.bold}>
                                  {t(`dayType.${item.dayType}`)}
                                </Box>
                                <Box>
                                  {item.shifts &&
                                    item.shifts.map(
                                      (estimateShift, indexShift) => {
                                        var totalPrice = 0;
                                        var price = 0;
                                        var totalHours = 0;
                                        var shiftType = estimateShift.shiftType;
                                        if (
                                          estimateShift.rate ||
                                          estimateShift.rate === 0
                                        ) {
                                          totalPrice =
                                            estimateShift.rate *
                                            estimateShift.totalHours;
                                          totalHours = estimateShift.totalHours;
                                          price = estimateShift.rate;
                                        } else {
                                          totalPrice = estimateShift.segmentPrice
                                            ? estimateShift.segmentPrice
                                            : estimateShift.remainingPrice
                                              ? estimateShift.remainingPrice
                                              : 0;
                                          totalHours = estimateShift.segmentHours
                                            ? estimateShift.segmentHours
                                            : estimateShift.remainingHours
                                              ? estimateShift.remainingHours
                                              : 0;
                                          price = estimateShift.segmentRateHours
                                            ? estimateShift.segmentRateHours
                                            : estimateShift.mainRateHours;
                                        }
                                        return (
                                          <Grid
                                            container
                                            key={`estimate-shift-${indexShift}`}
                                            // spacing={2}
                                          >
                                            <Grid item xs={6}>
                                              <span>{` ${t(
                                                `shift.${shiftType}`
                                              )} (${totalHours} hours): `}</span>
                                            </Grid>
                                            <Grid item xs={6}>
                                              <span>{`$${AppUtil.formatMoney(
                                                totalPrice.toFixed(2)
                                              )} `}</span>
                                              {isMobile ? <br /> : <></>}
                                              <span>{`($${AppUtil.formatMoney(
                                                price.toFixed(2)
                                              )}/hour)`}</span>
                                            </Grid>
                                          </Grid>
                                        );
                                      }
                                    )}
                                </Box>
                              </Box>
                            );
                          })}
                      </Box>
                  </Grid>
              </Grid>  
            }
            </Box>
            <Box className={classes.control}>
              {
                <React.Fragment>
                  <AppButton
                    label={`${t("button.back")}`}
                    mode="outlined"
                    onClick={() => setShowOptionBooking(false)}
                  />
                  <AppButton
                    label={`${t("button.book")}`}
                    rounder
                    onClick={() => {
                      confirmBookWorker();
                    }}
                    className="ml-2"
                    disabled={
                      isLoading || jobDetail.client?.status === "DEACTIVATE"
                    }
                    loading={isLoading}
                  />
                </React.Fragment>
              }
            </Box>
          </Box>
        )}
      </AppDialog>
      <AppDialog
        open={showAddShift}
        onClose={() => setShowAddShift(false)}
        maxWidth="xs"
        title={
          newShift.ignoreShift ? t("label.addShift") : t("label.addDayOfWeek")
        }
      >
        <Box>
          <ShiftForm
            isSubmitting={isLoading}
            onSubmit={handleAddShift}
            newShift={newShift}
            jobDetail={jobDetail}
            jobAvailabilities={jobAvailabilities}
            onCancel={() => setShowAddShift(false)}
            checkValidDate={checkValidDate}
            setIsLoading={setIsLoading}
          />
        </Box>
      </AppDialog>
      {/* <AppConfirmDialog
        open={showConfirmBookWorker}
        onConfirm={() => handleDeleteDayOfWeek()}
        onClose={() => {
          setShowConfirmBookWorker(false);
        }}
        isDisabledButton={isLoading || isSubmitting}
        title={t('title.confirmBookWorker')}
        content={t('text.messageConfirmBookWorker')}
      /> */}
    </Box>
  );
};

BookingWorkerModal.propTypes = {
  jobAvailabilities: PropTypes.array,
  jobId: PropTypes.any,
  jobDetail: PropTypes.any,
  onAddShift: PropTypes.func,
  loadJob: PropTypes.func,
  selectedWeek: PropTypes.object,
  setSelectedWeek: PropTypes.func,
  week: PropTypes.any,
  yearJobCalendar: PropTypes.any,
  date: PropTypes.any,
  dayOfWeek: PropTypes.any,
  shiftType: PropTypes.any,
  shiftId: PropTypes.any,
  setShiftId: PropTypes.any,
  setShiftType: PropTypes.any,
  setDayOfWeek: PropTypes.any,
  reload: PropTypes.bool,
  setReload: PropTypes.func,
};

export default BookingWorkerModal;

// const dataTest = [
//   {
//     weekNum: 0,
//     firstWeekDay: '',
//     lastWeekDay: '',
//     monday: [
//       {
//         shiftType: 'NIGHT',
//         jobAvailabilities: []
//       }
//     ],
//     SUNDAY: 0,
//     MONDAY: 1 ,
//     TUESDAY: 2,
//     WEDNESDAY: 3,
//     THURSDAY:4 ,
//     FRIDAY: 5,
//     SATURDAY: 6
//   }
// ]
